/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { bindActionCreators } from "redux";
import isEmpty from "lodash/isEmpty";

import { Modal } from "react-modal-bootstrap";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { sendToGTM } from "../../utils/gtmHelper";
import * as AnalyticsHelper from "../../utils/analyticsHelper";

require("./LoyaltyCartStrip.scss");

const text = {
  cashbackOnThisOrder: "cashback on this order",
  plusmemberBenefits: "PLUS membership benefits",
  popular: "Popular",
  selectPlan: "Select Plan",
  showBenefits: "Show Benefits",
};

class LoyaltyCartStrip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedVariant: {},
    };
  }

  componentDidMount() {
    sendToGTM({
      eventLabel: "i_element_viewed",
      eventDetails: {
        element_name: "ooc_loyalty_recommendation_bar_cart",
        element_unique_name: "ooc_loyalty_recommendation_bar",
        source: "p_ooc_cart",
        element_type: "recommendation",
        element_sub_type: "loyalty",
        //field specific to diag loyalty
        order_type: this.props.isDiagLoyaltyStrip ? "pathlab" : "",
        ...AnalyticsHelper.getCommonPayloadForAnalytics(
          this.props.customer,
          this.props.cart,
          this.props.user
        ),
      },
    });
  }

  onClose = (triggerEvent = true) => {
    this.setState({ showModal: false });
    if (triggerEvent) {
      if (this.props.isDiagLoyaltyStrip) {
        sendToGTM({
          eventLabel: "element_clicked",
          eventDetails: {
            element_unique_name: "ooc_loyalty_recommendation_bar_close",
            source: "p_ooc_cart",
            order_type: "pathlab",
            ...AnalyticsHelper.getCommonPayloadForAnalytics(
              this.props.customer,
              this.props.cart,
              this.props.user
            ),
          },
        });
      } else {
        sendToGTM({
          eventLabel: "i_recommendations_widget_clicked",
          eventDetails: {
            page_name: "ooc_cart",
            property_section_name: "body",
            property_name: "ooc_loyalty_recommendation_bar",
            property_cta: "close",
            action_type: "click",
            order_type: this.props.isDiagLoyaltyStrip ? "pathlab" : "",
            ...AnalyticsHelper.getCommonPayloadForAnalytics(
              this.props.customer,
              this.props.cart,
              this.props.user
            ),
          },
        });
      }
    }
  };

  onOpen = () => {
    this.setState({
      showModal: true,
      selectedVariant: this.props.isDiagLoyaltyStrip
        ? this.props.selectedDiagLPVariant
        : this.props.loyalty.variants[0],
      // this.props.loyalty.variants[0] || this.props.selectedDiagLPVariant,
    });
    if (this.props.isDiagLoyaltyStrip) {
      sendToGTM({
        eventLabel: "element_clicked",
        eventDetails: {
          element_unique_name: "ooc_loyalty_recommendation_bar",
          source: "p_ooc_cart",
          element_cta: "show_benefits",
          order_type: "pathlab",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    } else {
      sendToGTM({
        eventLabel: "i_recommendations_widget_clicked",
        eventDetails: {
          page_name: "ooc_cart",
          property_section_name: "body",
          property_name: "ooc_loyalty_recommendation_bar",
          property_cta: "show_benefits",
          action_type: "click",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    }
  };

  getStripText = () => {
    let loyaltySavings;
    let totalLoyaltyUserSavings;

    if (this.props.isDiagLoyaltyStrip) {
      loyaltySavings = this.props.diagCartPlusSavings;
    } else {
      const { userSavings: cartUserSavings } = this.props.loyaltyDetailsPitch;
      const { userSavings: totalUserSavings } = this.props.loyalty;
      loyaltySavings = cartUserSavings;
      totalLoyaltyUserSavings = totalUserSavings;
    }

    const userStatus = this.props.loyalty
      ? this.isExpired(this.props.loyalty.userStatus)
      : this.isExpired(this.props.lpUserStatus);

    if (userStatus) {
      if (+loyaltySavings > 0 && +totalLoyaltyUserSavings > 0) {
        return `₹${totalLoyaltyUserSavings} saved with plus till now, You save ₹${loyaltySavings} on this order`;
      }
      return "Renew PharmEasy Plus for the customer and help them save more.";
    }
    return "Customer can save more with additional benefits by enrolling for PharmEasy Plus";
  };

  isActive = (status) => status === 2;

  isOptedIn = (status) => status === 1;
  isInActive = (status) => status === 0;

  isPaymentPending = (status) => status === 5;
  isCancelled = (status) => status === 4;

  isExpired = (status) => status === 3;

  selectVariant = (variant) => {
    this.setState({ selectedVariant: variant });
  };

  notInterested = () => {
    if (this.props.isDiagLoyaltyStrip) {
      sendToGTM({
        eventLabel: "element_clicked",
        eventDetails: {
          element_unique_name: "ooc_loyalty_recommendation_bar",
          source: "p_ooc_cart",
          element_cta: "not_interested",
          order_type: "pathlab",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            // eslint-disable-next-line react/prop-types
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    } else {
      sendToGTM({
        eventLabel: "i_recommendations_widget_clicked",
        eventDetails: {
          page_name: "ooc_cart",
          property_section_name: "body",
          property_name: "ooc_loyalty_recommendation_bar",
          property_cta: "not_interested",
          action_type: "click",
          //
          order_type: this.props.isDiagLoyaltyStrip ? "pathlab" : "",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            // eslint-disable-next-line react/prop-types
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    }

    this.onClose(false);
  };

  atc = () => {
    this.props.actions.setLoyaltyData(this.state.selectedVariant);
    if (this.props.isDiagLoyaltyStrip) {
      this.props.addToCartDiagLP(
        this.props.programId,
        this.state.selectedVariant
      );
      sendToGTM({
        eventLabel: "element_clicked",
        eventDetails: {
          element_unique_name: "ooc_loyalty_recommendation_bar",
          source: "p_ooc_cart",
          element_cta: "add_to_cart",
          order_type: "pathlab",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            // eslint-disable-next-line react/prop-types
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    } else {
      this.props.actions.getCartItemsV5();
      sendToGTM({
        eventLabel: "i_recommendations_widget_clicked",
        eventDetails: {
          page_name: "ooc_cart",
          property_section_name: "body",
          property_name: "ooc_loyalty_recommendation_bar",
          property_cta: "add_to_cart",
          action_type: "click",
          ...AnalyticsHelper.getCommonPayloadForAnalytics(
            // eslint-disable-next-line react/prop-types
            this.props.customer,
            this.props.cart,
            this.props.user
          ),
        },
      });
    }

    this.onClose(false);
  };

  getOrderBenefitsText = ({ keyword, text }) => {
    return text.replace("%s", keyword);
  };
  render() {
    const { userSavings: cartUserSavings } = this.props.loyaltyDetailsPitch;
    const lpUserSavings = this.props.diagCartPlusSavings;

    const userStatus = this.props.loyalty
      ? this.isExpired(this.props.loyalty.userStatus)
      : this.isExpired(this.props.lpUserStatus);
    return (
      <div className="LoyaltyCartStrip">
        {userStatus ? (
          <div className="PlusTextExpired">
            <div className="stripText">
              <div className="expiredImgContainer">
                <img src={require("@images/plusPurpleBg.svg")} alt="Plus" />
                <div className="expiredText"> Expired </div>
              </div>
              <div>{this.getStripText()}</div>
            </div>
            <span>
              <button className="PlusButton" onClick={this.onOpen}>
                {" "}
                Renew Now{" "}
              </button>
            </span>
          </div>
        ) : (
          <div className="PlusText">
            {!isEmpty(this.props.loyaltyDetailsPitch) && (
              <span className="stripText">
                {/* <div className="expiredImgContainer"><img src={require('@images/plus.svg')} alt="Plus" /></div> */}
                {/* <div>{this.getStripText()}</div> */}
                <div className="PlusStripText">
                  <span>Become a</span>
                  <img src={require("@images/plus.svg")} alt="Plus" />
                  member and save extra ₹
                  {this.props.isDiagLoyaltyStrip
                    ? lpUserSavings
                    : cartUserSavings}
                </div>
              </span>
            )}
            <span>
              <button className="PlusButton" onClick={this.onOpen}>
                {this.props.isDiagLoyaltyStrip
                  ? text.selectPlan
                  : text.showBenefits}
              </button>
            </span>
          </div>
        )}
        <Modal
          className="imageGalleryModal"
          isOpen={this.state.showModal}
          onRequestHide={this.onClose}
          backdrop
        >
          <div className="modalHeader">
            <div className="headerText">
              Benefits
              <div className="closeIcon" onClick={this.onClose}>
                <img src={require("@images/crossIcon.svg")} alt="close" />
              </div>
            </div>

            {this.props.isDiagLoyaltyStrip && this.props.diagOrderBenefits && (
              <div>
                <div>
                  <h3 className="benefitsHeader">{text.cashbackOnThisOrder}</h3>

                  <ul className="resultContainer">
                    {this.props.diagOrderBenefits.map((benefit, index) => (
                      <div className="bullet" key={index}>
                        <img
                          src={require("@images/checkCircle.svg")}
                          alt="bullet"
                        />
                        <span className="benefitText">
                          {this.getOrderBenefitsText(benefit)}
                        </span>
                      </div>
                    ))}
                  </ul>
                </div>
                <hr className="breakline" />
              </div>
            )}

            <div>
              {this.props.isDiagLoyaltyStrip &&
                this.props.diagOrderBenefits && (
                  <h3 className="benefitsHeader"> {text.plusmemberBenefits}</h3>
                )}
              <ul className="resultContainer">
                {this.props.isDiagLoyaltyStrip &&
                  this.props.commonLPBenefits &&
                  this.props.commonLPBenefits.map((benefit, index) => (
                    <div className="bullet" key={index}>
                      <img
                        src={require("@images/checkCircle.svg")}
                        alt="bullet"
                      />
                      <span className="benefitText">{benefit}</span>
                    </div>
                  ))}
                {!this.props.isDiagLoyaltyStrip &&
                  this.props.loyaltyDetailsPitch.benefits.map(
                    (benefit, index) => (
                      <div className="bullet" key={index}>
                        <img
                          src={require("@images/checkCircle.svg")}
                          alt="bullet"
                        />
                        <span className="benefitText">{benefit}</span>
                      </div>
                    )
                  )}
              </ul>
            </div>
          </div>
          <div className="header">
            <div>
              <p className="heading">Select Membership Plan</p>
              <div className="variantContainer">
                {this.props.isDiagLoyaltyStrip && this.props.diagLoyaltyVariants
                  ? this.props.diagLoyaltyVariants.map((variant, index) => {
                      return (
                        <div
                          className={cx("variantContent", {
                            selectedVariantContent:
                              this.state.selectedVariant.id === variant.id,
                          })}
                          key={index}
                          onClick={() => this.selectVariant(variant)}
                        >
                          {index ===
                            this.props.diagLoyaltyVariants.length - 1 && (
                            <div className="popular">{text.popular}</div>
                          )}

                          <div className="radioCheckbox">
                            {this.state.selectedVariant.id === variant.id ? (
                              <div>
                                <img
                                  src={require("@images/tick.svg")}
                                  alt="selected"
                                />
                              </div>
                            ) : (
                              <div className="circle" />
                            )}
                          </div>
                          <div>
                            <div className="description">
                              {variant.duration} Plan
                            </div>
                            <div>
                              <span className="discountedAmount">
                                ₹{variant.discounted_amount}
                              </span>
                              <span className="originalAmount">
                                ₹{variant.amount}
                              </span>
                            </div>
                            {variant.monthly_cost && (
                              <div className="monthlyCost">
                                {variant.monthly_cost}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  : this.props.loyalty.variants.map((variant, index) => (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                      <div
                        className={cx("variantContent", {
                          selectedVariantContent:
                            this.state.selectedVariant.id === variant.id,
                        })}
                        key={index}
                        onClick={() => this.selectVariant(variant)}
                      >
                        {index === this.props.loyalty.variants.length - 1 && (
                          <div className="popular">{text.popular}</div>
                        )}

                        <div className="radioCheckbox">
                          {this.state.selectedVariant.id === variant.id ? (
                            <div>
                              <img
                                src={require("@images/tick.svg")}
                                alt="selected"
                              />
                            </div>
                          ) : (
                            <div className="circle" />
                          )}
                        </div>
                        <div>
                          <div className="description">
                            {variant.description} Plan
                          </div>
                          <div>
                            <span className="discountedAmount">
                              ₹{variant.discountedAmount}
                            </span>
                            <span className="originalAmount">
                              ₹{variant.amount}
                            </span>
                          </div>
                          {variant.monthly_cost && (
                            <div className="monthlyCost">
                              {variant.monthly_cost}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
              </div>
              <div className="buttonsContainer">
                <button className="notInterested" onClick={this.notInterested}>
                  Not interested
                </button>
                <button className="atc" onClick={this.atc}>
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

LoyaltyCartStrip.propTypes = {
  loyaltyDetailsPitch: PropTypes.object,
  loyalty: PropTypes.object,
  actions: PropTypes.object,
  customer: PropTypes.object,
  cart: PropTypes.object,
  user: PropTypes.object,
};

LoyaltyCartStrip.defaultProps = {
  loyaltyDetailsPitch: {},
  loyalty: {},
  actions: {},
  customer: {},
  cart: {},
  user: {},
};

export default connect(
  (state) => ({
    customerDetails: state.customerDetails,
    action: state.action,
    cart: state.cart,
    customer: state.customer,
    user: state.user,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(LoyaltyCartStrip);
